/** Lazy-loaded PDF export + pdf.js worker — keeps homepage bundle smaller until user exports or loads a PDF. */

let jsPDFPromise
let html2canvasPromise
let pdfWorkerUrlPromise

export function getJsPDF() {
  if (!jsPDFPromise) jsPDFPromise = import('jspdf').then((m) => m.default)
  return jsPDFPromise
}

export function getHtml2Canvas() {
  if (!html2canvasPromise) html2canvasPromise = import('html2canvas').then((m) => m.default)
  return html2canvasPromise
}

export async function configurePdfWorker(pdfjsLib) {
  if (!pdfWorkerUrlPromise) {
    pdfWorkerUrlPromise = import('pdfjs-dist/build/pdf.worker.min.mjs?url').then((m) => m.default)
  }
  pdfjsLib.GlobalWorkerOptions.workerSrc = await pdfWorkerUrlPromise
}
